import axios from 'axios';

const profileApi = axios.create({
    baseURL: `${process.env.VUE_APP_PROFILE_API}`
  })




export default profileApi